<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-2">
        <DashboardCard
          title="Pçs em recebimento"
          :total-value="this.getCardsOrders[0].QTD_PCSRECEBIMENTO"
          :loading="getLoadingCardsOrders"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Ordens em recebimento"
          :total-value="this.getCardsOrders[0].QTD_ORDRECEBIMENTO"
          :loading="getLoadingCardsOrders"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Ordens finalizadas/dia"
          :total-value="this.getCardsOrders[0].QTD_ORDFINALIZADASDIA"
          :loading="getLoadingCardsOrders"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Ordens finalizadas/mês"
          :total-value="this.getCardsOrders[0].QTD_ORDFINALIZADASMES"
          :loading="getLoadingCardsOrders"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          title="Pçs no estoque/dia"
          :total-value="this.getCardsOrders[0].QTD_PCSESTOQUEDIA"
          :loading="getLoadingCardsOrders"
        />
      </div>
      <div class="col-md-2">
        <DashboardCard
          :title="`Pçs no estoque/mês`"
          :total-value="this.getCardsOrders[0].QTD_PCSESTOQUEMES"
          :loading="getLoadingCardsOrders"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-8 dash">
        <DashboardPendingEntryOrders
          :value="valuePending()"
          :label="labelPending()"
          :loading="getLoadingPendingOrders"
        />
      </div>
      <div class="col-md-4 dash">
        <TableOpenOrders
          :Orders="this.getOpenOrders"
          :loading="getLoadingOpenOrders"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import DashboardPendingEntryOrders from './DashboardPendingEntryOrders.vue';
import DashboardCard from '@/modules/dashboard/components/DashboardCard.vue';
import TableOpenOrders from './TableOpenOrders.vue';
import { mapGetters } from 'vuex';
import { BarChart, LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

use([
  BarChart,
  LineChart,
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LegendComponent,
]);

export default defineComponent({
  components: {
    DashboardPendingEntryOrders,
    DashboardCard,
    TableOpenOrders,
  },

  methods: {
    pendingEntryOrders() {
      const data = this.getPendingEntryOrders;
      const maxDia = 5;
      const groups = {};
      for (let i = 0; i <= maxDia; i++) {
        groups[i] = 0;
      }
      groups[`>${maxDia}`] = 0;

      data.forEach((item) => {
        const dias = item.NRO_DIAS_ABERTO;
        const qtd = item.QTDE_ORDEM;

        if (dias <= maxDia) {
          groups[dias] += qtd;
        } else {
          groups[`>${maxDia}`] += qtd;
        }
      });

      const result = Object.keys(groups).map((key) => {
        const label =
          key === `>${maxDia}`
            ? `Mais de ${maxDia} dias`
            : `${key} ${key === '1' ? 'dia' : 'dias'}`;
        return { label, value: groups[key] };
      });

      return result.sort((a, b) => {
        if (a.label.includes('Mais de')) return 1;
        if (b.label.includes('Mais de')) return -1;
        return parseInt(a.label) - parseInt(b.label);
      });
    },

    labelPending() {
      return this.pendingEntryOrders().map((pending) => pending.label);
    },

    valuePending() {
      return this.pendingEntryOrders().map((pending) => pending.value);
    },
  },

  computed: {
    ...mapGetters('dashboardStock', {
      getPendingEntryOrders: 'getPendingEntryOrders',
      getOpenOrders: 'getOpenOrders',
      getCardsOrders: 'getCardsOrders',
      getLoadingPendingOrders: 'getLoadingPendingOrders',
      getLoadingOpenOrders: 'getLoadingOpenOrders',
      getLoadingCardsOrders: 'getLoadingCardsOrders',
      getSearchDate: 'getSearchDate',
      getSearchParams: 'getSearchParams',
    }),
    ...mapGetters('auth', { getFilteredDateYYYYMM: 'getFilteredDateYYYYMM' }),
  },
});
</script>
<style lang="scss" scoped>
.dash {
  position: relative;
}
</style>
